import React, { useState } from 'react';
import CodeInput from './code-step/CodeInput';
import PhoneInput from './phone-step/PhoneInput';
import RutAndDocumentInput from './rut-step/rut/RutAndDocumentInput';
import QuestionsComponent from './rut-step/questions/QuestionsComponent';
import FinalStepContent from './final-step/FinalStepContent';
import { StepContentProps } from '../../../interfaces/interfaceSteps';
import './StepContentRenderer.css';

const StepContentRenderer: React.FC<StepContentProps> = ({
  imageSrc,
  title,
  description,
  value,
  onChange,
  step,
  placeholders,
  onCheckboxChange,
  isCheckboxChecked,
  isCodeIncorrect,
  validateRut,
  validateDocumentNumber,
  rutError,
  documentNumberError,
  preguntas,
  hash,
  onRutAndDocValidityChange,
  onFinalStepChange,
  setIsServiceExecuted,
  setErrorMessage,
}) => {
  const [phoneValue, setPhoneValue] = useState<string>('');
  const [codeValue, setCodeValue] = useState<string[]>(Array(5).fill(''));

  const handlePhoneChange = (newPhoneValue: string) => {
    setPhoneValue(newPhoneValue);
    onChange(newPhoneValue);
  };

  const handleCodeChange = (newCodeValues: string[]) => {
    setCodeValue(newCodeValues);
    onChange(newCodeValues);
  };

  const handleQuestionsCompleted = (payload: {
    hash: string;
    respuestas: { id: string; pregunta: string; respuesta: string }[];
    isApproved: boolean;
  }) => {
    onFinalStepChange(true);
  };

  const handleValidation = (valid: boolean) => {
    onRutAndDocValidityChange(valid);
  };

  return (
    <>
      <div className={`step-header ${step === 4 ? "hidden" : ""}`}>
        <img
          className="steps-img"
          src={imageSrc || undefined}
          alt={title || undefined}
          data-step={step}
        />
        <h2 className="title">{title}</h2>
        <p>{description}</p>

        {step === 1 && (
          <PhoneInput
            value={phoneValue}
            onChange={handlePhoneChange}
            placeholders={{ phone: placeholders.phone }}
            onCheckboxChange={onCheckboxChange}
            isCheckboxChecked={isCheckboxChecked}
          />
        )}
        {step === 2 && (
          <CodeInput
            value={codeValue}
            onChange={handleCodeChange}
            placeholders={{ code: placeholders.code }}
            isCodeIncorrect={isCodeIncorrect}
            phoneNumber={phoneValue}
          />
        )}
        {step === 3 && (
          <RutAndDocumentInput
            value={Array.isArray(value) ? value : ["", "", ""]}
            onChange={onChange}
            placeholders={{
              rut: placeholders.rut,
              documentNumber: placeholders.documentNumber,
            }}
            validateRut={validateRut}
            validateDocumentNumber={validateDocumentNumber}
            rutError={rutError}
            documentNumberError={documentNumberError}
            onValidityChange={handleValidation}
            setIsServiceExecuted={setIsServiceExecuted}
            setErrorMessage={setErrorMessage}
          />
        )}

        {step === 4 && (
          <QuestionsComponent
            preguntas={preguntas}
            onQuestionsCompleted={handleQuestionsCompleted}
            hash={hash ?? ""}
          />
        )}
        {step === 5 && (
          <FinalStepContent
            status="error"
            responseCode="ERROR_CODE"
            responseHash=""
          />
        )}
      </div>
    </>
  );
};

export default StepContentRenderer;
